module.exports = "<div class=\"container\"  appHeight=\"90%\" [less]=\"less\">\r\n    <ag-grid-angular\r\n      style=\"height: 100%;\"\r\n      class=\"scrollbar scrollbar-hiden\"\r\n      [gridOptions]=\"historyGrid\">\r\n    </ag-grid-angular>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/driver-schedule/components/history-schedule/history-schedule.component.html
// module id = 2438
// module chunks = 66